






























































import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { AuthService } from "@/common/api/services/AuthService";
import defineAbilityFor from "@/services/ability";
import RegisterMember from "@/sites/user/pages/register.vue";
import RegisterMemberLine from "@/sites/user/pages/registerLine.vue";
import QErrors from "@/common/qErrors.vue";
import ForgotPassword from "@/sites/user/pages/forgotPassword.vue";
import { AppVersion } from "@/common/utils";

const auth = namespace("MemberAuth");

@Component({
  name: "LoginPage",
  components: {
    RegisterMember,
    RegisterMemberLine,
    QErrors,
    ForgotPassword,
  },
  directives: {},
})
export default class LoginPage extends Vue {
  @auth.Getter
  userLogging: any;
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateRefreshToken!: (refreshToken: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateRole!: (role: string) => void;
  @auth.Action
  setUser!: (user) => void;
  @auth.Action
  fetchCurrentUser!: () => void;

  private lineAccountId: any = "";

  private form = {
    email: "",
    password: "",
    device_token: "",
  };
  private errorMessage = "";
  errors = [];

  public appVersion = AppVersion();

  mounted() {
    this.lineAccountId = localStorage.getItem("line_account_id");
    if (this.lineAccountId) {
      this.showRegisterLinePopup();
    }
  }

  public async checkLineMember() {
    const response = await AuthService.lineGetUrl({});
    window.location.href = response.data.url;
  }

  private async submit() {
    let response: any;
    try {
      response = await AuthService.authMemberLogin(this.form);

      // Save it to state
      this.updateToken(response.data.token);
      this.updateRefreshToken(response.data?.refresh_token);
      await this.fetchCurrentUser();

      // Set ability
      this.$ability.update(defineAbilityFor("member").rules);

      this.$router.push({ name: "mypage" });
    } catch (error: any) {
      response = error.body;
      this.errors = response.errors;
      if (this.errors.length === 0) {
        this.errorMessage = response.message;
      }
    }
  }

  private showRegisterPopup() {
    (this.$refs.registerMemmberPopup as RegisterMember).show();
  }

  private showRegisterLinePopup() {
    (this.$refs.registerMemmberLinePopup as RegisterMemberLine).show();
  }

  private forgotPasswordPopup() {
    (this.$refs.forgotPasswordPopup as ForgotPassword).show();
  }
}
